import en from "react-phone-number-input/locale/en";
import fr from "react-phone-number-input/locale/fr";
import it from "react-phone-number-input/locale/it";
import es from "react-phone-number-input/locale/es";
import de from "react-phone-number-input/locale/de";
export const locales = {
    en,
    fr,
    it,
    es,
    de,
};
